import endPoints from '../settings/endPoints';
import qs from 'qs';

export default function getEndpoint(level, service) {
    let endPoint = '';
    let lvl = level;
    const missingEnvmsg =
        "%c If you don't have the services running locally, you may want to pass a services environment as a query param. ie  &env=test";
    const consoleFormatting =
        'color: #0088ff; font-size: 14px; background-color: #ffc600; padding: 10px; font-weight: bold';

    const { env: envQueryParam, localService } = qs.parse(
        qs.parse(window.location.search.split('?'))[1]
    );

    const isRunningLocally = process.env.NODE_ENV === 'development';
    if (isRunningLocally) {
        //ability to use other baseURIs locally
        if (envQueryParam) {
            lvl = envQueryParam;
        } else {
            console.info(missingEnvmsg, consoleFormatting);
        }
        if (localService) lvl = 'localhost';
    }

    try {
        endPoint = endPoints[lvl][service];
    } catch (e) {
        console.error(e);
    }

    return endPoint;
}



// WEBPACK FOOTER //
// ./src/modules/getEndpoint.js